export default __webpack_public_path__ + "static/media/uber-eat.55d8c759.jpg";